
import { Icon } from '@chakra-ui/react';
export const NetchexPerformance = (props) => (
  <Icon viewBox="0 0 20 20" boxSize="16px" color="icon.g1" {...props}>
<path d="M10.3081 7.40002H14.6832" stroke="#4B5563" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M5.31641 7.40002L5.94141 8.02502L7.81641 6.15002" stroke="#4B5563" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10.3081 13.2333H14.6832" stroke="#4B5563" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M5.31641 13.2333L5.94141 13.8583L7.81641 11.9833" stroke="#4B5563" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M7.49983 18.3333H12.4998C16.6665 18.3333 18.3332 16.6667 18.3332 12.5V7.50002C18.3332 3.33335 16.6665 1.66669 12.4998 1.66669H7.49983C3.33316 1.66669 1.6665 3.33335 1.6665 7.50002V12.5C1.6665 16.6667 3.33316 18.3333 7.49983 18.3333Z" stroke="#4B5563" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
</Icon>
  );
